import { getDynamicButtonsTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";
import { DYNAMIC_BUTTONS_EVENT_TYPES } from "@/constant";

const dynamicButtonsConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const dynamicButtonsWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Dynamic Buttons",
    url: "/dynamic-buttons-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        dynamicButtonsWindow.sendMessage({
          type: DYNAMIC_BUTTONS_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      // Generate HTML template with data
      const template = getDynamicButtonsTemplate(currentData);
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, template, "dynamic-buttons");

      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute(
        "data-dynamic-buttons-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );
      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);

      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === DYNAMIC_BUTTONS_EVENT_TYPES.UPDATE_DYNAMIC_BUTTONS_DATA) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === DYNAMIC_BUTTONS_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 700,
  });
};

export { dynamicButtonsConfig };
